import { Pencil, Trash2, Sparkles, PenLine } from "lucide-react";
import { CATEGORIES, catLabel } from "@/lib/categories";
import { useI18n } from "@/lib/i18n";
import SourceChip from "@/components/SourceChip";

export default function ItemCard({ item, onEdit, onDelete }) {
  const { t, lang } = useI18n();
  const cat = CATEGORIES[item.category] || {};
  return (
    <div
      data-testid={`item-card-${item.id}`}
      className="group p-5 border border-zinc-800 bg-[#18181d] rounded-lg flex flex-col gap-3 relative hover:border-zinc-700 transition-colors animate-fade-up"
    >
      <div className="flex justify-between items-center gap-3">
        <span className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded border text-[11px] font-mono-ui font-medium uppercase tracking-wider ${cat.chip}`}>
          <span className={`h-1.5 w-1.5 rounded-full ${cat.dot}`} />
          {catLabel(item.category, lang)}
        </span>
        <div className="flex items-center gap-2.5">
          {item.ai_generated ? (
            <span className="flex items-center gap-1 font-mono-ui text-[10px] text-zinc-600">
              <Sparkles className="h-3 w-3" /> AI
            </span>
          ) : (
            <span className="flex items-center gap-1 font-mono-ui text-[10px] text-zinc-600">
              <PenLine className="h-3 w-3" /> {t("item.manual")}
            </span>
          )}
          <button data-testid={`edit-item-${item.id}`} onClick={() => onEdit(item)}
            className="opacity-0 group-hover:opacity-100 transition-opacity text-zinc-500 hover:text-zinc-200">
            <Pencil className="h-3.5 w-3.5" />
          </button>
          <button data-testid={`delete-item-${item.id}`} onClick={() => onDelete(item)}
            className="opacity-0 group-hover:opacity-100 transition-opacity text-zinc-500 hover:text-rose-400">
            <Trash2 className="h-3.5 w-3.5" />
          </button>
        </div>
      </div>

      <p className="text-[15px] leading-relaxed text-zinc-200">{item.content}</p>

      <div className="flex items-center gap-2 flex-wrap">
        {item.date && (
          <span className="font-mono-ui text-[11px] text-zinc-500 px-2 py-1 bg-zinc-800/40 rounded-md">
            {item.date}
          </span>
        )}
        <SourceChip item={item} />
        {item.edited && <span className="font-mono-ui text-[10px] text-amber-500/70">{t("item.edited")}</span>}
      </div>
    </div>
  );
}
